import { noop } from 'lodash/fp';
import { Dispatch, Middleware } from 'redux';

import { createHandler } from '@mews/std';

import { REPLACE_STATE_URL } from './actions';
import { ReplaceStateUrlAction } from './types';

interface CreateHistoryMiddlewareOptions {
    getDocumentTitle: () => string;
    history: History;
}

export const createHistoryMiddleware = <S = unknown, D extends Dispatch = Dispatch>({
    getDocumentTitle,
    history,
}: CreateHistoryMiddlewareOptions): Middleware<{}, S, D> => {
    const handler = createHandler(
        {
            [REPLACE_STATE_URL]: ({ payload }: ReplaceStateUrlAction) => {
                const { url } = payload;
                const { state } = history;
                history.replaceState({ ...state }, getDocumentTitle(), url);
            },
        },
        noop
    );

    return () => (next) => (action) => {
        handler(action.type, action);
        return next(action);
    };
};
